import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllAccounts,
  resetJournals,
} from "../../redux/slice/accounting/accountingSlice";
import Journal from "./../modals/accounting/Journal";
import FilterAccounts from "./FilterAccounts";
import { v4 as uuid } from "uuid";
import JournalTable from "./JournalTable";
import PageTitle from "../partials/PageTitle";

const Journals = () => {
  const [hasCreateJournal, setHasCreateJournal] = useState();
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const dispatch = useDispatch();
  const [data, getSearcInput] = useState({});
  const [refreshKey, setRefreshKey] = useState(null);

  const breadcrumb = {
    from: {
      title: "Accounting",
      link: "/admin/accounting/journals",
    },
    current: {
      title: "Journals",
      link: null,
    },
  };

  useEffect(() => {
    dispatch(getAllAccounts());
    dispatch(resetJournals());
  }, []);

  useEffect(() => {
    setHasCreateJournal(
      user_permissions?.some(
        (permission) => permission.name === "create journal entry"
      )
    );
  }, [user_permissions]);

  return (
    <>
      <PageTitle title='Journals' breadcrumb={breadcrumb} />
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='d-flex justify-content-between'>
                {/* start here */}
                <div>
                  {hasCreateJournal && (
                    <div
                      className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary text-white cursor-p'
                      data-bs-toggle='modal'
                      data-bs-target='#staticBackdrop'
                      style={{ height: "30px", padding: "10px 10px" }}
                    >
                      <span>
                        <i className='mdi mdi-plus fs-4'></i>
                      </span>
                      <span href='#' className='text-dark pe-2 text-white'>
                        Create Journals Entry
                      </span>
                    </div>
                  )}
                </div>
                <Journal
                  modal_id='staticBackdrop'
                  formRefresh={refreshKey}
                  setRefreshKey={setRefreshKey}
                />
              </div>
              <FilterAccounts getSearcInput={getSearcInput} />
              <JournalTable data={data} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Journals;
